import { connect } from "react-redux";
import generateUUID from "uuid/v4";

import { addDlsUserMaterial } from "~/store/actions/dls";
import NewModal from "./NewModal";

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: formData => {
    dispatch(
      addDlsUserMaterial({
        _id: generateUUID(),
        type: "dlsUserMaterial",
        ...formData
      })
    );
    ownProps.hideModal();
  }
});

export default connect(null, mapDispatchToProps)(NewModal);
